export default __webpack_public_path__ + "static/angelikao-c36f6429f3bd90794cb7c7104aa17385.webp";